export default "__VITE_ASSET__9exttoJj__"